import { useMemo } from "react";
import Seo from "@/components/feature/Seo";
import { faqs } from "@/mocks/faqs";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import LatestGrid from "./components/LatestGrid";
import Categories from "./components/Categories";
import Featured from "./components/Featured";
import Stats from "./components/Stats";
import FaqPreview from "./components/FaqPreview";
import Subscribe from "./components/Subscribe";

const keywords =
  "国产吃瓜视频,国产吃瓜视频最新,国产吃瓜视频热点,国产吃瓜视频事件,国产吃瓜视频八卦,国产吃瓜视频汇总,国产吃瓜视频速递";

export default function HomePage() {
  const jsonLd = useMemo(() => {
    const base = window.location.origin;
    return [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "吃瓜速递 · 国产吃瓜视频热点速递站",
        url: base,
        description:
          "国产吃瓜视频最新热点实时速递，聚焦近期热门吃瓜事件与八卦汇总，持续更新视频内容。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${base}/events?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "吃瓜速递",
        url: base,
        description: "国产吃瓜视频热点事件与八卦汇总速递站",
      },
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "国产吃瓜视频 · 最新热点与八卦汇总速递",
        url: base,
        description:
          "国产吃瓜视频最新热点实时速递，聚焦近期热门吃瓜事件与八卦汇总，持续更新视频内容。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 4).map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ];
  }, []);

  return (
    <>
      <Seo
        title="国产吃瓜视频 · 最新热点与八卦汇总速递站"
        description="国产吃瓜视频最新热点实时速递，聚焦近期热门吃瓜事件与八卦汇总，持续更新视频内容。想看国产吃瓜视频最新、热点事件或完整汇总，收藏本站每日刷新即可。"
        keywords={keywords}
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <HotRank />
      <LatestGrid />
      <Categories />
      <Featured />
      <Stats />
      <FaqPreview />
      <Subscribe />
    </>
  );
}